"use client";
import { CN_PRODUCT } from "@/components/product/const";
import { useTranslation } from "@/i18n/client";

export default function NewShopperActivity() {
  const { t } = useTranslation();
  return (
    <div className={CN_PRODUCT("new-shopper")}>
      <span className="flag">{t("welcome.title")}</span>
    </div>
  );
}
